export class Base {
  public active: boolean;
  public reasonForDeletion: string;
  public createdDateTime: string;
  public createdBy: string;
  public updatedDateTime?: string;
  public updatedBy: string;
}
